import React, { useState } from "react";
import axios from "axios";
import { MdAdd } from "react-icons/md";
import { useAddSupplierMutation } from "../../features/api/supplierApi";
import { toast } from "react-toastify";

const NewSupplier = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [addNewSupplier] = useAddSupplierMutation();

  const [s_name, setName] = useState("");
  const [s_email, setEmail] = useState("");
  const [s_address, setAddress] = useState("");
  const [s_phone, setPhone] = useState("");
  const [s_mobile, setMobile] = useState("");
  const [s_web, setWeb] = useState("");
  const handleAdd = async () => {
    try {
      const newSupplier = {
        s_name,
        s_email,
        s_address,
        s_phone,
        s_mobile,
        s_web,
      };
      const result = await addNewSupplier(newSupplier);

      if (result) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Supplier create success...!!!");

        setName("");
        setEmail("");
        setAddress("");
        setPhone("");
        setMobile("");
        setWeb("");
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span
        onClick={openModal}
        className="text-white bg-blue-500 px-2 py-1 rounded flex items-center cursor-pointer"
      >
        <MdAdd className="text-xl font-bold " /> New Supplier
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md md:w-[600px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold">Add New Supplier</h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 overflow-auto w-full">
                    <input
                      type="text"
                      onChange={(e) => setName(e.target.value)}
                      className="border pl-1"
                      placeholder="Name"
                    />
                    <input
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                      className="border pl-1"
                      placeholder="Email"
                    />
                    <input
                      type="text"
                      onChange={(e) => setAddress(e.target.value)}
                      className="border pl-1"
                      placeholder="Address"
                    />
                    <input
                      type="text"
                      onChange={(e) => setPhone(e.target.value)}
                      className="border pl-1"
                      placeholder="Phone"
                    />
                    <input
                      type="text"
                      onChange={(e) => setMobile(e.target.value)}
                      className="border pl-1"
                      placeholder="Mobile"
                    />
                    <input
                      type="text"
                      onChange={(e) => setWeb(e.target.value)}
                      className="border pl-1"
                      placeholder="Website"
                    />
                  </div>
                  <button
                    onClick={() => handleAdd()}
                    className="bg-green-500 text-white font-bold mt-6 px-4 block m-auto"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewSupplier;